// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"c278f7e8","129":"708b9e31"}[chunkId] + ".chunk.js";
};